export { default as PromoBanner } from './PromoBanner';
